import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import HotspotServerBody from './HotspotServerBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import HotspotServerProvider from './context/HotspotServerProvider';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const HotspotServer = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <HotspotServerProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - Hotspot Server" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <HotspotServerBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </HotspotServerProvider>
    </div>
  );
};

export default HotspotServer;
